export enum FetchType {
  new = 'new',
  old = 'old',
  all = 'all',
}
export interface ICriteria {
  generic: boolean;
  isSearch: boolean;
  limit: number;
  page: number;
  products: string;
  categories: string;
  gameName: string;
  role: string;
  userId: string;
  username: string;
  source: string;
  sort: string;
  isElastic: boolean;
  fetchType: FetchType;
  isNewModel: boolean;
  isOutstanding: boolean;
  isComposite: boolean;
  start: {
    date: string;
  };
  end: {
    date: string;
  };
}
